module.exports = __webpack_public_path__ + "media/V104.3c33636d.mp4";